/**
 * Normalize input value by handling different decimal separators and removing invalid characters
 */
export const normalizeInputValue = (input: string): string => {
  if (!input) {
    return input;
  }
  input = "" + input;
  if (input.includes(".") && input.includes(",")) {
    // e.g. 1.234,56 => 1 234,56 or 2.000.000,00 becomes 2 000 000,00
    input = input.replaceAll(".", " ");
  }
  return input.replaceAll("e", "").trim();
};

/**
 * Clean input by converting separators and removing spaces
 */
export const cleanInput = (input: string): string => {
  input = normalizeInputValue(input);
  return input ? input.replaceAll(",", ".").replaceAll(" ", "") : input;
};

/**
 * Validate numeric input based on constraints
 */
export const validate = (
  input: string,
  options: {
    validationCounter: number;
    required: boolean;
    onlyInts: boolean;
    min: number;
    max: number;
  },
): boolean => {
  const { validationCounter, required, onlyInts, min, max } = options;

  if ((validationCounter === 0 || !required) && input === "") {
    return true;
  }

  input = normalizeInputValue(input);

  if (onlyInts) {
    const intRegex = /^[+-]?([0-9 ]*)$/;
    if (intRegex.test(input)) {
      const numericValue = Number.parseInt(cleanInput(input));
      return numericValue >= min && numericValue <= max;
    }
    return false;
  }

  const floatRegex = /^[+-]?([0-9 ]*[,.])?[0-9 ]+$/;
  if (floatRegex.test(input)) {
    const numericValue = Number.parseFloat(cleanInput(input));
    return numericValue >= min && numericValue <= max;
  }
  return false;
};
